import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency, EmergencyAttachment } from '@/store/emergency/emergency.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    emergencyId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const emergency = computed<Emergency | undefined>(() => store.getters[EmergencyGetter.BY_ID](props.emergencyId));
    const attachments = computed<EmergencyAttachment[]>(() => (emergency.value) ? emergency.value?.emergencyAttachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<EmergencyAttachment[]>(() => (emergency.value) ? emergency.value?.emergencyAttachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
